module.exports = __webpack_public_path__ + "assets/img/banner1.5eda9fe6.png";